module.exports = __webpack_public_path__ + "static/media/ebupot-logotype-l.bdf0cc34.svg";